<ras-page>
	<ras-video-banner *ngIf="video" [video]="video.code" [preview]="video.preview" [position]="video.position" text="We'll take care of it."></ras-video-banner>
	<ras-top-banners></ras-top-banners>

	<p align="center">More reasons to love Rent-A-Store | <a onclick="document.getElementById('reasons-to-love').scrollIntoView({behavior: 'smooth'})">Click here</a></p>

	<main>
		<h1>Furniture Storage</h1>

		<h2>Choose a furniture storage facility near you, find your unit and get a quick quote with an OTP</h2>

		<p>Reserve online with no obligation or reservation fees</p>

		<div class="choose-location">
			<div *ngFor="let item of locations | keyvalue">
				<ras-location-thumb [location]="item.value"></ras-location-thumb>
			</div>
		</div>

		<h2>Rent-A-Store Furniture Storage - The Benefits</h2>

		<p>Finding a safe and secure space to store furniture items is not easy. Perhaps you are scaling down, have inherited extra furniture or are moving in with a partner and now have two of everything. Whether you need to store one furniture item or store multiple pieces of furniture, we provide furniture storage units of all sizes to suit almost every furniture storage need.</p>

		<p><strong>There are many great benefits to storing your furniture in a self-storage unit:</strong></p>

		<ol>
			<li>Peace of mind - your stored furniture items are safe 24/7</li>
			<li>Longevity – by using a professional furniture storage facility, your furniture is protected against pests and water damage</li>
			<li>Access – you can access your stored furniture seven days of the week</li>
			<li>More space – by storing your excess furniture items, office equipment or appliances you free up space for more useful items</li>
		</ol>

		<br>

		<p><strong>Select the furniture storage facility in Gauteng that is closest to you and get a FREE quote today!</strong></p>

	</main>

	<ras-reasons-to-love></ras-reasons-to-love>

	<ras-box-banner></ras-box-banner>

	<ras-testimonial></ras-testimonial>
</ras-page>
